import React from 'react';
import PropTypes from 'prop-types';
import PrivacyPage from '../components/FullPrivacy';
import TemplateWrapper from '../layouts';

export const PrivacyPageTemplate = ({
  title, sections, html,
}) => (
  <PrivacyPage
    title={title}
    sections={sections}
    html={html}
  />
);

export default ({ data }) => { // eslint-disable-line react/prop-types
  const { frontmatter, html } = data.markdownRemark;
  return (
    <TemplateWrapper>{
      () => (
        <PrivacyPageTemplate
          title={frontmatter.title}
          sections={frontmatter.sections}
          html={html}
        />
      )
    }
    </TemplateWrapper>
  );
};

PrivacyPageTemplate.propTypes = {
  title: PropTypes.string.isRequired, // eslint-disable-line react/forbid-prop-types,
  sections: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types,
  html: PropTypes.string.isRequired,
};

// eslint-disable-next-line no-undef
export const privacyPageQuery = graphql`
  query PrivacyPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        sections {
          section_object {
            id
            title
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/privacy-page.jsx